import { Alert, AuthHeader, AuthLayout, Button } from "@nabble/ui";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../auth/AuthContext";
import { destinationAfterStep } from "../../../auth/session";
import { TotpSetup } from "../../../components/TotpSetup";
import { ChooseAnotherMethod } from "./ChooseAnotherMethod";
import { MethodChoice } from "./MethodChoice";
import { SaveRecoveryCodesStep } from "./SaveRecoveryCodesStep";
import { useMfaEnrollment } from "./useMfaEnrollment";

export default function EnrollMfaPage(): React.JSX.Element {
  const navigate = useNavigate();
  const { applyNext } = useAuth();
  const enrollment = useMfaEnrollment();
  const { choice, choose, loading, error, enrolled } = enrollment;

  if (enrolled) {
    return (
      <SaveRecoveryCodesStep
        codes={enrolled.recoveryCodes}
        onContinue={() => {
          applyNext(enrolled.next, enrolled.rememberedUntil);
          navigate(destinationAfterStep(enrolled.next));
        }}
      />
    );
  }

  return (
    <AuthLayout wide={choice === "totp"} step={{ current: 2, total: 4, label: "second factor" }}>
      {!choice ? (
        <>
          <AuthHeader
            title="Set up your second factor"
            lead="It's required for every account: besides your password, we'll ask you for a verification when you sign in."
          />
          <div className="nb-auth-content">
            {error ? <Alert tone="danger">{error}</Alert> : null}
            <MethodChoice onTotp={() => choose("totp")} onPasskey={() => choose("passkey")} />
          </div>
        </>
      ) : choice === "totp" ? (
        <>
          <AuthHeader title="Set up your second factor" lead="Link your authenticator app to Nabble Suite." />
          <div className="nb-auth-content">
            <TotpSetup start={enrollment.startTotp} confirm={enrollment.confirmTotp} error={error} onStartError={enrollment.onTotpStartError} />
          </div>
          <ChooseAnotherMethod onClick={enrollment.back} />
        </>
      ) : (
        <>
          <AuthHeader icon="key" title="Register your passkey" lead="Your browser will ask you to confirm with Face ID, Touch ID, Windows Hello or your security key." />
          <div className="nb-auth-content">
            {error ? <Alert tone="danger">{error}</Alert> : null}
            <Button label="Register passkey" icon="key" size="lg" block loading={loading} onClick={() => void enrollment.enrollPasskey()} />
          </div>
          <ChooseAnotherMethod onClick={enrollment.back} />
        </>
      )}
    </AuthLayout>
  );
}
